namespace Matrix.Data {
    export class TestColumns {
        static columnsKey = 'Data.Test';
    }
}
